import { uiText } from '../i18n/uiText';
// Display aliases do not rewrite existing company or audit records.
export const COMPANY_CATEGORIES = [
  { value: 'supplier', label: uiText("Поставщик") },
  { value: 'partner', label: uiText("Партнёр") },
];

export function companyCategories(values = []) {
  const aliases = { contractor: 'supplier', ecosystem_entity: 'partner' };
  return [...new Set((values || []).map(value => aliases[value] || value))];
}
